import React, { FunctionComponent, ReactNode } from 'react';
import styles from './progress-step-item.module.scss';
import classNames from 'classnames/bind';

export interface IProgressStepItemProps {
  children: ReactNode;
  index: number;
  isActive: boolean;
  stepItemIsDone: boolean;
  changeStep: (event: React.MouseEvent<HTMLElement>) => void;
}

const cx = classNames.bind(styles);

export const ProgressStepItem: FunctionComponent<IProgressStepItemProps> = ({
  children,
  isActive,
  index,
  stepItemIsDone,
  changeStep
}) => {
  const stepItemClasses = cx({
    stepItemActive: isActive,
    stepItemIsDone: stepItemIsDone
  });

  return (
    <div
      className={`${styles.stepItem} ${stepItemClasses}`}
      data-index={index}
      onClick={changeStep}
    >
      <div className={styles.stepIcon}>
        {stepItemIsDone ? (
          <i className={'material-icons md-secondary-text md-36 md-bold'}>
            done
          </i>
        ) : (
          `0${index + 1}`
        )}
      </div>
      <div className={styles.stepText}>{children}</div>
    </div>
  );
};
